var exports = {
  "O": "FavoritesGuildHeader.module__headerIconContainer___WFY4NU",
  "n": "FavoritesGuildHeader.module__headerIcon___WFY4NU",
};

module.exports = exports;
